import React from 'react';
import { Table, Tooltip, Button, Col } from 'antd';
import 'moment-timezone';
import { useTranslation } from "react-i18next";

const MeterReadingTable = ({ devices, count, columns, pagination, loading, handleTableChange, getDetailsUI }) => {
    const { t } = useTranslation();

    return (
        <Table
            // rowKey={(record) => `${record.operationId}-${record.serial}`}
            dataSource={devices}
            columns={columns}
            pagination={{
                ...pagination,
                size: 'small',
                total: count,
                disabled: loading,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
            onChange={handleTableChange}
            loading={loading}
            bordered
            expandable={{
                expandedRowRender: record => (
                    <span style={{ background: '#ffffff' }}>
                        <Col span={18} offset={3}>
                             {record && <div>{getDetailsUI(record.response)}</div>}
                        </Col>
                    </span>
                ),
                rowExpandable: record => record.name !== 'Not Expandable',
                expandIconColumnIndex: 9,
                expandIcon: ({ expanded, onExpand, record }) => (
                    <Tooltip placement="top" title={expanded ? t('label_hideDetails') : t('label_details')}>
                        <Button
                            type="link"
                            size="small"
                            onClick={e => onExpand(record, e)}
                        >
                            {expanded ? t('label_hideDetails') : t('label_details')}
                        </Button>
                    </Tooltip>
                )
            }}
        />
    );
};

export default MeterReadingTable;
